import { generateUniqueId } from '../internal/hooks/use-unique-id';
import { useMemo } from 'react';
export var useDropdownA11yProps = function (listId, open, highlightedOption) {
    var id = useMemo(function () { return highlightedOption && generateUniqueId(); }, [highlightedOption]);
    var inputProps = useMemo(function () { return ({
        'aria-autocomplete': 'list',
        'aria-activedescendant': id,
        'aria-expanded': open,
        'aria-haspopup': 'listbox',
        'aria-owns': listId,
        role: 'combobox'
    }); }, [id, open, listId]);
    var itemProps = { id: id };
    return [inputProps, itemProps];
};
//# sourceMappingURL=a11y.js.map